module.exports = __webpack_public_path__ + "img/random-rounded.89af1827.svg";